module.exports = __webpack_public_path__ + "img/icons-fill-implements-sapphire.48892a5b.svg";